import { Helmet } from "react-helmet";
import Footer from "../../common/Footer";
import Header from "../../common/Header";
import Section from "../../common/Section";


function ContactPage() {

    return (
        <div className="customer-stories">
            <Header location="other" />
            <Helmet>
                <title>Turgoil - Kliendilood ja uudised</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0, user-scalable=no"
                />
            </Helmet>
            <Section backgroundColor="white">
                <div className="contactPage">
                    <div className="left" >
                        <div className="line1">VÕTA ÜHENDUST</div>
                        <div className="line2">Räägime Teie vedelkütuste ostust</div>
                        <div className="line3">Oleme siin, et aidata Teil leida sobiv lahendus ja vastata kõigile küsimustele, mis puudutavad Turgoili kasutamist.</div>
                    </div>
                    <div className="right">
                        <div className="line1">Võta meiega ühendust</div>
                        <div className="line2">
                            <div className="icon">
                                <img src="images/svg/phone.svg" alt="phone" />
                            </div>
                            <div>
                                <div className="customTitle">Helista meile</div>
                                <div>+372 513 89 40</div>
                                <div>E-R 8:30-17:00</div>
                            </div>
                        </div>
                        <div className="line3">
                            <div className="icon">
                                <img src="images/svg/email.svg" alt="email" />
                            </div>
                            <div>
                                <div className="customTitle">Kirjuta meile</div>
                                <div>info@turgoil.com</div>
                                <div>Vastame tööpäeval 24h jooksul</div>
                            </div>

                        </div>
                    </div>
                </div>
            </Section>

            <Footer rootFolder="../../../" />
        </div>
    );
}
export default ContactPage;
